import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  chartBackground: {
    padding: `${theme.spacing(10)}px ${theme.spacing(2)}px ${theme.spacing(3)}px 0`,
    width: '100%'
  },
  chart: {
    padding: '0px !important',
    position: 'relative'
  }
}))
